import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from '@app/app.config';
import { App } from '@app/app';
import * as Sentry from '@sentry/browser';
import { BrowserTracing } from '@sentry/tracing';
import { environment } from './environments/environment';
import 'iconify-icon';

const sentryDsn = environment.sentryDsn;

if (sentryDsn) {
  const sentryEnvironment = environment.sentryEnvironment;
  const sentryRelease = environment.sentryRelease;
  const tracesSampleRate = Number(environment.sentryTracesSampleRate ?? 0);
  const enableTracing = tracesSampleRate > 0;

  Sentry.init({
    dsn: sentryDsn,
    environment: sentryEnvironment,
    release: sentryRelease || undefined,
    integrations: enableTracing
      ? [
          new BrowserTracing({
            tracePropagationTargets: [
              /^https?:\/\/localhost[:/]/,
              /^https?:\/\/api\.fluxtail\.io/,
              /^https?:\/\/stream\.fluxtail\.io/,
            ],
          }),
        ]
      : [],
    tracesSampleRate: enableTracing ? tracesSampleRate : 0,
  });
}

// Initialize theme
const theme = localStorage.getItem('theme') ||
              (window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light');
document.documentElement.setAttribute('data-theme', theme);
if (theme === 'dark') {
  document.documentElement.classList.add('dark');
}

bootstrapApplication(App, appConfig)
  .catch((err) => console.error(err));
